import React from 'react';
import {
  Box,
  Link as ChakraLink,
  Heading,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';

import { useSite } from '../../../site/siteApi';
import { SiteMeterData } from './meter-config-types';

type SiteDetailsProps = {
  selectedMeter: SiteMeterData;
};

export const SiteDetails = ({ selectedMeter }: SiteDetailsProps) => {
  const { site, isLoading } = useSite(selectedMeter.siteId);

  return (
    <Box>
      <Heading size="md" fontWeight={600} mb={4}>
        Site Details - {selectedMeter.siteName || 'N/A'}
      </Heading>

      <Skeleton isLoaded={!isLoading} w="100%" h="100%" minH={100}>
        <Text mb={1} opacity={0.8}>
          <strong>Address:</strong> {site?.site_address_line1 || 'N/A'}
        </Text>
        <TableContainer
          bg={'white'}
          _dark={{ bg: 'gray.900' }}
          w="100%"
          border={'1px solid'}
          borderColor={'gray.200'}
          borderRadius={8}
          data-testid="site-details-table"
        >
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th fontSize="13px" py={3} textAlign={'center'}>
                  ID
                </Th>
                <Th fontSize="13px" textAlign={'center'}>
                  NMI
                </Th>
                <Th fontSize="13px" textAlign={'center'}>
                  Meter Configuration
                </Th>
                <Th fontSize="13px" textAlign={'center'}>
                  Electrical configuration
                </Th>
                <Th fontSize="13px" textAlign={'center'}></Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td border="none !important" textAlign={'center'}>
                  {site?.clipsal_solar_id ?? 'N/A'}
                </Td>
                <Td border="none !important" textAlign={'center'}>
                  {site?.nmi ?? 'N/A'}
                </Td>
                <Td border="none !important" textAlign={'center'}>
                  {site?.metering_configuration ?? 'N/A'}
                </Td>
                <Td border="none !important" textAlign={'center'}>
                  {site?.electrical_config ?? 'N/A'}
                </Td>
                <Td border="none !important" textAlign={'center'}>
                  <ChakraLink
                    as={ReactRouterLink}
                    to={`/site/${site?.clipsal_solar_id}/start`}
                    color={'customLinkBlue.500'}
                  >
                    View Site
                  </ChakraLink>
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      </Skeleton>
    </Box>
  );
};
